// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTableMobileSort-HeaderLabel_cls1__pRLsP","cls2":"VeloTableMobileSort-HeaderLabel_cls2__T4djV VeloTableMobileSort-HeaderLabel_cls1__pRLsP"};